module.exports = __webpack_public_path__ + "images/help/video-permission-small@2x-4a89c56cb39dfa492ffcbdb7ca73b5ba.png";